import {ValueObject} from '@s-ui/domain'

import {InvalidParamsSharedError} from '../Errors/InvalidParamsSharedError.js'

export class NumberSharedValueObject extends ValueObject {
  #value

  static validate({number}) {
    if (isNaN(number)) {
      throw InvalidParamsSharedError.create(`[NumberSharedValueObject.validate] number(${number}) should be a number`)
    }
  }

  static normalize({value}) {
    return typeof value === 'string' ? Number(value) : value
  }

  static isEmpty({value}) {
    return value === undefined || value === null
  }

  static create({value}) {
    const normalizedNumber = NumberSharedValueObject.normalize({value})
    const isEmpty = NumberSharedValueObject.isEmpty({value})
    !isEmpty && NumberSharedValueObject.validate({number: normalizedNumber})
    return new NumberSharedValueObject({value: normalizedNumber})
  }

  constructor({value}) {
    super()
    this.#value = value
  }

  get isEmpty() {
    return this.#value === undefined || this.#value === null
  }

  get value() {
    return this.#value
  }

  toJSON() {
    return {value: this.#value}
  }
}
